<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import AnnouncementBadges from '@/components/appDriver/newsfeed/components/AnnouncementBadges.svelte'
  import type { NewsPost } from '@/components/appDriver/newsfeed/types'
  import { formatNewsDate, getNewsExcerpt } from '@/components/appDriver/newsfeed/utils'

  const dispatch = createEventDispatcher<{ open: { post: NewsPost } }>()

  export let post: NewsPost
  export let isRead = false
</script>

<button
  type="button"
  class="w-full overflow-hidden rounded-2xl border border-slate-200/70 bg-white text-left shadow-sm transition active:scale-[0.99]"
  on:click={() => dispatch('open', { post })}
>
  <div class="flex items-start gap-3 p-4">
    <div class="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full {isRead ? 'bg-gray-300' : 'bg-blue-primary'}"></div>

    <div class="min-w-0 flex-1 space-y-4">
      {#if post.coverImage}
        <div class="overflow-hidden rounded-xl bg-slate-100">
          <img
            src={post.coverImage}
            alt={post.title}
            class="h-44 w-full object-cover"
          >
        </div>
      {/if}

      <div class="space-y-2">
        <div class="text-lg font-bold leading-7 text-slate-900">
          {post.title}
        </div>

        <div class="flex items-center justify-between gap-3 text-xs text-slate-400">
          <div class="font-medium">ອັບເດດຫຼ້າສຸດ: {formatNewsDate(post.lastUpdate)}</div>
          {#if !isRead}
            <div class="font-semibold text-blue-primary">ໃໝ່</div>
          {/if}
        </div>

        <div class="text-sm leading-6 text-slate-600">
          {getNewsExcerpt(post)}
        </div>
      </div>

      <div class="flex items-center justify-between gap-3 border-t border-slate-100 pt-3">
        <AnnouncementBadges {post}/>
        <div class="text-xs font-semibold text-slate-500">ແຕະເພື່ອເບິ່ງ</div>
      </div>
    </div>
  </div>
</button>
